<app-gallery-list
  *ngIf="(viewMode === galleryViewMode.List) && !loading && results"
  [checkable]="checkable"
  [showActions]="showActions"
  [results]="results"
  [columns]="columns"
  [selectLabel]="selectLabel"
  (selectBookmark)="handleSelect($event)"
  [checkable]="checkable"
  [checkedResults]="checkedResults"
  (checkedChange)="handleCheckedChange($event)"
  [galleryActionsTemplate]="galleryActionsTemplate"
  [galleryTagsTemplate]="galleryTagsTemplate"
  [showActions]="showActions"></app-gallery-list>

<app-gallery-cards
  *ngIf="(viewMode === galleryViewMode.Cards) && !loading && results"
  [results]="results"
  [columns]="columns"
  [selectLabel]="selectLabel"
  (selectBookmark)="handleSelect($event)"
  [checkable]="checkable"
  [checkedResults]="checkedResults"
  (checkedChange)="handleCheckedChange($event)"
  [galleryActionsTemplate]="galleryActionsTemplate"
  [galleryTagsTemplate]="galleryTagsTemplate"
  [showActions]="showActions"></app-gallery-cards>
  
<app-spinner *ngIf="loading" size="large" label="Loading..."></app-spinner>

<div class="no-results text-dim text-14 text-uppercase text-light" *ngIf="!loading && results && results?.length === 0">No Models Found</div>